var _path, _path2, _path3, _line, _line2, _rect, _rect2, _rect3, _rect4, _rect5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPreModelingSteps(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 44 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8172 13.9041C14.5728 15.0567 12.7402 16.0709 12.7402 16.1631C12.7402 16.3706 20.8117 20.543 21.2029 20.543C21.5324 20.543 29.8098 16.3475 29.8098 16.1631C29.8098 15.9787 21.5324 11.7833 21.1824 11.7833C21.0176 11.7833 19.0409 12.7284 16.8172 13.9041Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4766 22.3655V27.555L15.902 29.7665L20.3274 32V26.7886V21.5772L19.382 21.1392C18.8389 20.8984 16.8474 19.8911 14.9566 18.9277L11.4766 17.176V22.3655Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6118 19.4281L22.2266 21.6364V26.8182V32L25.7066 30.2509C27.5974 29.2888 29.5889 28.2831 30.132 28.0426L31.0774 27.6053V22.3798C31.0774 19.4937 31.0573 17.1542 31.0372 17.1761C30.997 17.198 29.0055 18.2037 26.6118 19.4281Z",
    fill: "currentColor"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 14.4447,
    y2: -0.5,
    transform: "matrix(-0.716679 0.697403 -0.951211 -0.308542 42.7793 2.61719)",
    stroke: "currentColor"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 14.4447,
    y2: -0.5,
    transform: "matrix(-0.716679 -0.697403 0.951211 -0.308542 11.3516 12.6914)",
    stroke: "currentColor"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.85742,
    width: 5.23787,
    height: 5.23787,
    fill: "currentColor"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16.7148,
    y: 6.54688,
    width: 2.61893,
    height: 2.61893,
    fill: "currentColor"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 23.2617,
    y: 6.54688,
    width: 2.61893,
    height: 2.61893,
    fill: "currentColor"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 19.334,
    width: 2.61893,
    height: 2.61893,
    fill: "currentColor"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 27.1895,
    width: 5.23787,
    height: 5.23787,
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreModelingSteps);
export default __webpack_public_path__ + "static/media/PreModelingSteps.f569099fe727dbe45ce377b2cffcea79.svg";
export { ForwardRef as ReactComponent };